export default {
  state: {
    detail: null,
    urlQuery: null,
    selectedRabList: null,
    rabQueueIndex: 0
  },
  mutations: {
    setRabDetail(state, payload) {
      state.detail = payload
    },
    setRabPageQuery(state, payload) {
      state.urlQuery = payload
    },
    setRabQueue(state, payload) {
      state.selectedRabList = payload.list
      state.rabQueueIndex = payload.index
    }
  },
  actions: {},
  getters: {
    getRabDetail(state) {
      return state.detail
    },
    getRabPageQuery(state) {
      return state.urlQuery
    },
    getRabList(state) {
      return {
        list: state.selectedRabList,
        index: state.rabQueueIndex
      }
    }
  }
}
